import styled from 'styled-components';
import Block from 'common/components/TouchpointEditor/components/TouchpointNodes/Block';

export const BlockVariation = styled(Block)`
    width: 100%;
    height: 100%;
    font-weight: bold;
    gap: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 600px;
`;
